export const PRACTICE_CASE_TYPES = [
  { value: "personal_injury", label: "Personal Injury" },
  { value: "contract_dispute", label: "Contract Dispute" },
  { value: "employment", label: "Employment" },
  { value: "insurance_dispute", label: "Insurance Dispute" },
  { value: "criminal_defense", label: "Criminal Defense" },
  { value: "family_law", label: "Family Law" },
  { value: "business_litigation", label: "Business Litigation" }
];

export const PRACTICE_JURISDICTIONS = [
  { value: "us_federal", label: "US Federal" },
  { value: "us_ca", label: "California" },
  { value: "us_ny", label: "New York" },
  { value: "us_tx", label: "Texas" },
  { value: "us_fl", label: "Florida" },
  { value: "us_il", label: "Illinois" },
  { value: "uk", label: "United Kingdom" },
  { value: "canada", label: "Canada" },
  { value: "australia", label: "Australia" },
  { value: "eu_general", label: "European Union" },
  { value: "germany", label: "Germany" },
  { value: "france", label: "France" },
  { value: "international", label: "International" }
];
